import { Alert, Box } from 'app/components/design-system-components'
import {
  Text,
  TextSeparatorDot,
} from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'

const DATABASE_REF = [
  {
    title: 'NTD',
    phone: '1300 563 826',
    url: 'www.tenancydatabase.com.au',
  },
  {
    title: 'TICA',
    phone: '1902 220 346',
    url: 'www.tica.com.au',
  },
  {
    title: 'RP DATA',
    phone: '1300 734 318',
    url: 'www.rpdata.com',
  },
  {
    title: 'BARCLAY MIS',
    phone: '1300 883 916',
    url: 'www.barclaymis.com.au',
  },
  {
    title: 'TRA',
    phone: '02 9363 9244',
    url: 'www.tradingreference.com',
  },
]

const TenancyDatabases = ({ ...props }) => {
  return (
    <Alert variant="blueWithBg" {...props}>
      <Box color="deepBlue">
        <Text as="h4" mb={5}>
          Tenancy Databases
        </Text>
        <Text fontSize={theme.fontSizes.pLarge16}>
          A property manager/owner can use tenancy databases to check an
          applicant’s tenancy history. The following databases may be used to
          check an applicant’s tenancy history. An applicant may contact the
          tenancy databases using the following details.
        </Text>

        {DATABASE_REF.map((item, index) => (
          <Text fontSize={theme.fontSizes.pLarge16} mt={6} key={index}>
            {item.title}{' '}
            <TextSeparatorDot
              mr={4}
              ml={4}
              mb={'2px'}
              bgColor={theme.colors.gray}
              borderColor={theme.colors.gray}
              radius="6px"
              as="span"
            />
            <a href={`tel:${item.phone.replaceAll(' ', '')}`}>{item.phone} </a>
            <TextSeparatorDot
              mr={4}
              ml={4}
              mb={'2px'}
              bgColor={theme.colors.gray}
              borderColor={theme.colors.gray}
              radius="6px"
              as="span"
            />
            <a href={`https://${item.url}`} target="_blank" rel="noreferrer">
              {item.url}
            </a>
          </Text>
        ))}
      </Box>
    </Alert>
  )
}

export default TenancyDatabases
